import React, { useEffect, useRef } from 'react'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { EmployeeDataHoc } from '../../utils/hocs'
import { MisSingleSelect } from '../common/atoms'
import { successOrFailureToaster } from '../common/atoms/messages'
import { SALES_ROLE } from '../../constants/overview'
import { dropdownDownArrow, dropdownUpArrow } from '../../assets/images'
import { MultiSelect } from 'react-multi-select-component'
import SelectInput from '../common/atoms'
import MisApi from '../../services/mis.api'
import ToggleButton from '../common/atoms/ToggleButton'

const AddMisPulse = (props) => {
  const [editMisId, setEditMisId] = useState(props.location.state?.data?.id)
  const [editMisData, setEditMisData] = useState(props.location.state?.data)
  const [state, setState] = useState({ benefits: [], frequency: '', mappings: [], emails: '', day_of_week: '', day_of_month: '', statuses: [], cumulative: false, broker: false, reimbursement: false, cashless: false, split_package: false, mis_start_date: '', pulse_type: 'opd' })
  let history = useHistory()
  const benefits = ['ahc', 'dental', 'vision', 'flu_vaccination']
  const statuses = ['partially_received', 'received', 'verification_required', 'confirmed', 'new', 'cancelled', 'rescheduled']
  const days_mapping = [{ id: '0', label: 'Sunday' }, { id: '1', label: 'Monday' }, { id: '2', label: 'Tuesday' }, { id: '3', label: 'Wednesday' }, { id: '4', label: 'Thursday' }, { id: '5', label: 'Friday' }, { id: '6', label: 'Saturday' }]
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

  const mappings = [
    'ek_id', 'email', 'name', 'policy_number', 'member_id', 'age', 'active', 'guardian_ek_id', 'relation', 'parent_company_id', 'sponsor',
    'sponsor_name', 'employee_id', 'vip', 'registered_time', 'appointment_id',
    'appointment_date', 'appointment_time', 'appointment_type', 'appointment_status', 'masked_package_name',
    'tagging', 'package_id', 'package_name', 'package_payment_type', 'enterprise_id',
    'provider_id', 'diagnostic_center', 'dc_branch_name', 'provider_city', 'mrp', 'selling_price', 'invoice_amount',
    'partner_masking_id', 'pending_tests', 'medical_records_count', 'rating', 'comment',
    'options', 'package_tests', 'customer_type', 'gender', 'date_of_birth', 'department', 'invoice_date', 'reports_received_date', 'confirmed_time'
  ]

  const optionsMapping = (options) => options.map((p) => ({ value: p, label: p }));

  const mapping_option = optionsMapping(mappings);
  const benefits_option = optionsMapping(benefits);
  const statuses_option = optionsMapping(statuses);

  const CustomItemRenderer = ({
    checked,
    option,
    onClick,
    disabled,
  }) => (
    <div className={`item-renderer ${disabled ? 'disabled' : 'font-heavy items-center'}`}
      style={{ display: 'flex', alignItems: 'center' }}>
      <div >
        <input
          className='p-8'
          type='checkbox'
          onChange={onClick}
          checked={checked}
          tabIndex={-1}
          disabled={disabled}
        />
      </div>
      <div>
        <span style={{ verticalAlign: 'middle', marginTop: '3px', display: 'flex', alignItems: 'center' }}>{option.label}</span></div>
    </div>
  );

  const setSubState = (newState) => {
    setState(prevState => { return { ...prevState, ...newState } })
  }

  const inputRef = useRef();

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.setProperty('--placeholder-color', '#aaa');
    }
  }, []);

  useEffect(() => {
    if (editMisData) {
      setState({
        benefits: editMisData.benefits.map((b) => ({ value: b, label: b })),
        frequency: editMisData.frequency,
        mappings: editMisData.mappings.map((m) => ({ value: m, label: m })),
        emails: editMisData.emails.join(', '),
        day_of_week: days_mapping.find((d) => d.id === editMisData.day_of_week)?.label || '',
        day_of_month: editMisData.day_of_month || '',
        statuses: editMisData.statuses.map((s) => ({ value: s, label: s })),
        cumulative: editMisData.cumulative,
        broker: editMisData.broker,
        reimbursement: editMisData.reimbursement,
        cashless: editMisData.cashless,
        split_package: editMisData.split_package,
        mis_start_date: editMisData.mis_start_date,
        pulse_type: editMisData.pulse_type
      });
    }
  }, [editMisData]);

  const onSave = async () => {
    const mis_pulse = {
      ...state,
      benefits: state.benefits.map((b) => b.value),
      statuses: state.statuses.map((s) => s.value),
      mappings: state.mappings.map((m) => m.value),
      day_of_week: days_mapping.find((d) => d.label === state.day_of_week)?.id || null,
    };

    const apiFunction = editMisId ? MisApi.updateMisPulse : MisApi.createMisPulse;

    apiFunction(
      { data: { mis_pulse }, id: editMisId },
      (res) => {
        successOrFailureToaster({ message: editMisId ? 'Mis Pulse updated successfully' : 'Mis Pulse created successfully' });
        history.push('/mis-pulse');
      },
      (err) => {
        successOrFailureToaster({ message: 'Operation failed', type: 'error' });
      }
    );
  };

  const formHandler = (event) => {
    let name = '', value = ''
    name = event.name
    value = event.value
    if (name === 'frequency' && value === 'daily') {
      setSubState({ day_of_week: '', day_of_month: '' })
    }
    setSubState({ ...state, [name]: value })
  }

  const ArrowRenderer = ({ expanded }) => <img src={expanded ? dropdownUpArrow : dropdownDownArrow} />;

  return (
    <React.Fragment>
      <EmployeeDataHoc
        classes='pb-32'
        title='Add Mis Pulse'
        breadcrumb={[{ text: 'Mis pulse', link: '/mis-pulse' }, { text: 'Add Mis Pulse', link: '#' }]}
        close={() => history.goBack()}
      >
        <h1 className='text-sm font-semibold tracking-widest leading-3 text-gray-500 mt-6 mb-3'>DETAILS</h1>
        <div className='bg-white rounded-md border'>
          <div className='grid grid-cols-2 gap-x-4 gap-y-6 p-6'>
            <MisSingleSelect
              onChangeHandler={formHandler}
              value={state.frequency}
              data={['daily', 'weekly', 'monthly']}
              name='frequency'
              placeholder='Select'
              label='FREQUENCY'
              labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
              listClasses='z-20'
              listItemClasses='capitalize px-4 py-2'
              bgColor='bg-gray-100 capitalize'
              placeholderClasses='h-4'
            />
            {state.frequency === 'weekly' && <MisSingleSelect
              onChangeHandler={formHandler}
              value={state.day_of_week}
              data={days}
              name='day_of_week'
              placeholder='Select'
              label='DAY OF WEEK'
              labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
              listClasses='z-20'
              listItemClasses='capitalize px-4 py-2'
              bgColor='bg-gray-100 capitalize'
              placeholderClasses='h-4'
            />}
            {state.frequency === 'monthly' && <MisSingleSelect
              onChangeHandler={formHandler}
              value={state.day_of_month}
              data={[...Array(31).keys()].map((i) => i + 1)}
              name='day_of_month'
              placeholder='Select'
              label='DAY OF MONTH'
              labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
              listClasses='z-20'
              listItemClasses='capitalize px-4 py-2'
              bgColor='bg-gray-100 capitalize'
              placeholderClasses='h-4'
            />}
            <div>
              <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'>
                BENEFITS
              </div>
              <div className='font-semibold  text-gray-500 cursor-pointer'>
                <MultiSelect
                  className="mis"
                  options={benefits_option}
                  value={state.benefits}
                  onChange={(e) => formHandler({ name: 'benefits', value: e })}
                  labelledBy='Select'
                  ItemRenderer={CustomItemRenderer}
                  ArrowRenderer={ArrowRenderer}
                  overrideStrings={{ 'selectSomeItems': 'Select' }}
                />
              </div>
            </div>
            <div>
              <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'>
                STATUSES
              </div>
              <div className='font-semibold  text-gray-500 cursor-pointer'>
                <MultiSelect
                  className="mis"
                  options={statuses_option}
                  value={state.statuses}
                  onChange={(e) => formHandler({ name: 'statuses', value: e })}
                  labelledBy='Select'
                  ItemRenderer={CustomItemRenderer}
                  ArrowRenderer={ArrowRenderer}
                  overrideStrings={{ 'selectSomeItems': 'Select' }}
                />
              </div>
            </div>
            <div>
              <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'>
                MAPPINGS
              </div>
              <div className='font-semibold  text-gray-500 cursor-pointer'>
                <MultiSelect
                  className="mis"
                  options={mapping_option}
                  value={state.mappings}
                  onChange={(e) => formHandler({ name: 'mappings', value: e })}
                  labelledBy='Select'
                  ItemRenderer={CustomItemRenderer}
                  ArrowRenderer={ArrowRenderer}
                  overrideStrings={{ 'selectSomeItems': 'Select' }}
                />
              </div>
            </div>
            <div className='flex justify-start'>
              <div className='w-full text-gray-500 '>
                <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3 '>EMAILS</div>
                <div className='text-gray-500'>
                  <input type='text' name='emails' value={state.emails} placeholder='Add emails' onChange={(e) => formHandler({ name: 'emails', value: e.target.value })} className={`text-sm bg-gray-100 border text-gray-500 border-gray-200 pl-5 rounded-md w-full h-12 placeholder-gray-300`} />
                </div>
              </div>
            </div>
            <div className='flex justify-start'>
              <div className='w-full text-gray-500 '>
                <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3 '>MIS START DATE</div>
                <div className='text-gray-500'>
                  <input type='date' name='mis_start_date' value={state.mis_start_date} placeholder='Add MIS Start Date' onChange={(e) => formHandler({ name: 'mis_start_date', value: e.target.value })} className={`text-sm bg-gray-100 border text-gray-500 border-gray-200 pl-5 rounded-md w-full h-12 placeholder-gray-300`} />
                </div>
              </div>
            </div>
             <MisSingleSelect
              onChangeHandler={formHandler}
              value={state.pulse_type}
              data={['opd', 'utilization']}
              name='pulse_type'
              placeholder='Select'
              label='PULSE TYPE'
              labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
              listClasses='z-20'
              listItemClasses='capitalize px-4 py-2'
              bgColor='bg-gray-100 capitalize'
              placeholderClasses='h-4'
            />
          </div>
          <div className='flex flex-row flex-wrap justify-start items-center p-6 border-t'>
            <div className="ml-6 flex items-center text-center mb-4">
              <div className="text-xs font-semibold tracking-widest leading-3 text-gray-500 mr-4">
                CUMULATIVE
              </div>
              <span className={`px-2.5 relative hover:bg-blue-100 self-center pt-2 pb-1 2xl:pt-2.5 2xl:pb-1.5 rounded-md`}> <ToggleButton name='cumulative' toggle={state.cumulative} onChangeHandler={(e) => formHandler(e)} /></span>
            </div>
            <div className="ml-6 flex items-center text-center mb-4">
              <div className="text-xs font-semibold tracking-widest leading-3 text-gray-500 mr-4">
                BROKER
              </div>
              <span className={`px-2.5 relative hover:bg-blue-100 self-center pt-2 pb-1 2xl:pt-2.5 2xl:pb-1.5 rounded-md`}> <ToggleButton name='broker' toggle={state.broker} onChangeHandler={(e) => formHandler(e)} /></span>
            </div>
            <div className="ml-6 flex items-center text-center mb-4">
              <div className="text-xs font-semibold tracking-widest leading-3 text-gray-500 mr-4">
                REIMBURSEMENT
              </div>
              <span className={`px-2.5 relative hover:bg-blue-100 self-center pt-2 pb-1 2xl:pt-2.5 2xl:pb-1.5 rounded-md`}> <ToggleButton name='reimbursement' toggle={state.reimbursement} onChangeHandler={(e) => formHandler(e)} /></span>
            </div>
            <div className="ml-6 flex items-center text-center mb-4">
              <div className="text-xs font-semibold tracking-widest leading-3 text-gray-500 mr-4">
                CASHLESS
              </div>
              <span className={`px-2.5 relative hover:bg-blue-100 self-center pt-2 pb-1 2xl:pt-2.5 2xl:pb-1.5 rounded-md`}> <ToggleButton name='cashless' toggle={state.cashless} onChangeHandler={(e) => formHandler(e)} /></span>
            </div>
            <div className="ml-6 flex items-center text-center mb-4">
              <div className="text-xs font-semibold tracking-widest leading-3 text-gray-500 mr-4">
                SPLIT PACKAGE
              </div>
              <span className={`px-2.5 relative hover:bg-blue-100 self-center pt-2 pb-1 2xl:pt-2.5 2xl:pb-1.5 rounded-md`}> <ToggleButton name='split_package' toggle={state.split_package} onChangeHandler={(e) => formHandler(e)} /></span>
            </div>
          </div>
          <div className='p-4 text-right border' style={{ backgroundColor: '#f5f8ff' }}>
            <button className='border border-gray-275 text-base leading-4 text-blue-600 font-semibold py-3.5 px-6 rounded-md focus:outline-none' onClick={() => history.goBack()}>
              Cancel
            </button>
            <button type='submit' disabled={SALES_ROLE === 'sales'} className={`bg-blue-600 leading-4 text-base text-white font-semibold py-3.5 px-6 rounded-md ml-3 focus:outline-none hover:bg-blue-600 ${SALES_ROLE === 'sales' ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={onSave}>
              {editMisId ? 'Update' : 'Save'}
            </button>
          </div>
        </div>
      </EmployeeDataHoc>
    </React.Fragment>
  )
}

export default AddMisPulse